export function filterOrdersByDate(orders, hoursAgo) {
    if (!Array.isArray(orders)) return []
    const now = new Date()
    const nowUTC = new Date(now.toUTCString())
    const millisecondsAgo = hoursAgo * 60 * 60 * 1000
    const cutoffDate = new Date(nowUTC - millisecondsAgo)
    const minDate = new Date('2025-04-04T00:00:00Z')

    return orders.filter(order => {
        const orderDate = new Date(order.date)
        return !isNaN(orderDate) && orderDate >= minDate && orderDate >= cutoffDate && orderDate <= nowUTC && order.status === 'successful' && order.reseller?.name !== 'Bianca' && order.reseller?.name !== 'Emperor Admin'
    })
}

export function filterOrdersByPackage(orders, pkg) {
    return orders.filter(order => order.packageEDName === pkg)
}

export function getResellerOrders(orders, reseller) {
    return orders.filter(order => order.reseller?.id === reseller._id)
  }

export function getRevenue(orders) {
    return orders.reduce((sum, order) => sum + (order.amount || 0), 0)
}

export function getCost(orders) {
    return orders.reduce((sum, order) => sum + (order.cost || 0), 0)
}

export function numberWithCommas(x) {
    return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')
}